<template>
    <Observer @on-change="onChange" :threshold="[0, 0.25, 0.5, 0.65, 1]">
        <div v-if="mobileAnimData && desktopAnimData">
            <LottieAnimation
                ref="lottieMobile"
                class="mobile-lottie"
                :animation-data="mobileAnimData"
                :auto-play="false"
                :loop="false"
                :speed="1"
                style="width: 100%; height:100%"
            />
            <LottieAnimation
                ref="lottieDesktop"
                :class="{'desktop-lottie': true, 'lottie-width-contained': animation.animation_size === 'contained' }"
                :animation-data="desktopAnimData"
                :auto-play="false"
                :loop="false"
                :speed="1"
                style="width: 100%; height:100%"
            />
        </div>
    </Observer>
</template>

<script>
import Observer from "vue-intersection-observer";
import LottieAnimation from "lottie-web-vue"
import axios from "axios"

export default {
    name: "lottie",

    data() {
        return {
            lottieMobile: null,
            mobileAnimData: null,
            lottieDesktop: null,
            desktopAnimData: null,
        };
    },

    methods: {
        async init() {
            this.mobileAnimData = await this.loadJsonData(this.animation.mobile_animation)
            this.desktopAnimData = await this.loadJsonData(this.animation.desktop_animation)
        },
        async loadJsonData(path) {
            return await axios.get(path).then(response => {
                return response.data;
            });
        },
        onChange(entry) {
            if (entry.intersectionRatio >= 0.5) {
                this.lottieMobile?.play();
                this.lottieDesktop?.play();
            }
            if (entry.intersectionRatio === 0) {
                this.lottieMobile?.stop();
                this.lottieDesktop?.stop();
            }
        }
    },

    async mounted() {
        await this.init();

        this.lottieMobile = this.$refs.lottieMobile;
        this.lottieDesktop = this.$refs.lottieDesktop;
    },

    components: {
        Observer,
        LottieAnimation
    },

    props: {
        animation: {
            mobile_animation: "",
            desktop_animation: ""
        }
    }
};
</script>

<style lang="scss">
.mobile-lottie {
    display: none;
}

.desktop-lottie {
    max-width: 1280px;
    display: block;
    margin-inline: auto;
}

.desktop-lottie.lottie-width-contained {
    max-width: 555px;
    // max-width: clamp(450px, 26vw, 640px)!important;
}

@media only screen and (max-width: 767px) {
    .mobile-lottie {
        display: block;
    }

    .desktop-lottie {
        display: none;
    }
}
</style>
